import { API } from "aws-amplify";
import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { config } from "../config";
import Home from "../containers/home/Home";
import { OffLineAPI } from "../offline-auth/api";
const _API = config.isOffline ? OffLineAPI : API

window.Cookies = require("js-cookie");

function querystring(name, url = window.location.href) {
  name = name.replace(/[[]]/g, "\\$&");

  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function validateSetup(data) {
  // console.log("Decisition", data);
  // if(data){
  return "/dashboard";
  // }else {
  //     return "/setup";
  // }
}

function validateActions(url, cProps) {
  if (url === "affiliate") {
    if (cProps.isAffiliate) {
      return "referral";
    } else {
      return url;
    }
  }

  return url;
}

export default ({ component: C, props: cProps, ...rest }) => {
  // console.log("Root Action", cProps);

  const redirect = querystring("redirect");
  const referrer = querystring("ref");
  const coupon = querystring("coupon");

  let redirect_path = redirect;
  redirect_path +=
    coupon && coupon !== "" && !redirect?.includes("coupon=")
      ? `?coupon=${coupon}`
      : "";

  // console.log("unauth------", coupon);

  useEffect(() => {
    const ref_coc = window.Cookies.get("inclassreferrer");
    // console.log("ref_coc..................", ref_coc, referrer);
    if (
      referrer &&
      (ref_coc === undefined || (ref_coc && ref_coc !== referrer))
    ) {
      window.Cookies.set("inclassreferrer", referrer, { expires: 1, path: "" });
      window.Cookies.set("inclasscoupon", coupon, { expires: 1, path: "" });

      let body = {
        // referral_url : window.location.href,
        userId: referrer,
        productCode: "INCLASS",
      };
      _API
        .post("inaffiliateUser", "/referrerclicks", { body })
        .then((res) => {
          // console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [referrer]);
  // let mcu_key = config.isOffline ? 'mcuServer' : 'custom:mcuServer';
  // <Redirect
  //             to={redirect === "" || redirect === null ? validateSetup(cProps.userPayload[mcu_key]) : validateActions(redirect, cProps)}
  //           />}

  // console.log("search ==== ", cProps, rest);
  // console.log("redirect unauth page ===========", redirect);
  return (
    <Route
      {...rest}
      render={(props) =>
        !cProps.isAuthenticated ? (
          <Home
            {...props}
            {...cProps}
            component={(props) => <C {...cProps} {...props} />}
          />
        ) : (
          <Redirect
            // to={
            //   redirect === "" || redirect === null
            //     ? "/dashboard"
            //     : `/${props.location.search}`
            // }
            to={redirect === "" || redirect === null ? "/dashboard" : redirect}
          />
        )
      }
    />
  );
};

//<C {...props} {...cProps} />

//component={C}
